import { api } from './client'
import type { Outline, Project, ProjectDetail, Script, StoredOutline, StoredScript } from '../types/api'

function projectFromApi(raw: Record<string, unknown>): Project { return raw as unknown as Project }

export async function listProjects() {
  const rows = await api<Record<string, unknown>[]>('/api/projects')
  return (rows || []).map(projectFromApi)
}

export async function getProject(id: string) {
  const raw = await api<Record<string, unknown>>(`/api/projects/${encodeURIComponent(id)}`)
  const outlines = Array.isArray(raw.outlines) ? raw.outlines as StoredOutline[] : []
  const scripts = Array.isArray(raw.scripts) ? raw.scripts as StoredScript[] : []
  return { ...projectFromApi(raw), outlines, scripts } as ProjectDetail
}

export async function createProject(body: { title: string; description?: string; materials?: Project['materials'] }) {
  return projectFromApi(await api<Record<string, unknown>>('/api/projects', { method: 'POST', body: JSON.stringify(body) }))
}

type ProjectUpdate = Partial<Pick<Project, 'title' | 'description' | 'materials' | 'status'>> & {
  stage_status?: Partial<Project['stage_status']>
}

export async function updateProject(id: string, body: ProjectUpdate) {
  return projectFromApi(await api<Record<string, unknown>>(`/api/projects/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(body) }))
}

export const deleteProject = (id: string) => api<void>(`/api/projects/${encodeURIComponent(id)}`, { method: 'DELETE' })

export async function saveOutline(id: string, content: Outline) {
  const raw = await api<Record<string, unknown>>(`/api/projects/${encodeURIComponent(id)}/outlines`, { method: 'POST', body: JSON.stringify({ content }) })
  return raw as unknown as StoredOutline
}

export async function saveScript(id: string, content: Script) {
  const raw = await api<Record<string, unknown>>(`/api/projects/${encodeURIComponent(id)}/scripts`, { method: 'POST', body: JSON.stringify({ content }) })
  return raw as unknown as StoredScript
}
